import { ADMIN_ROLE as o } from "../../../../constants/index.js";
import { useMe as r } from "../useMe.js";
import { useOrganizations as e } from "../useOrganizations.js";
const p = () => {
  const {
    organizations: a
  } = e(), {
    data: i
  } = r();
  return i?.role === o ? [...(a ?? []).filter((n) => n.name && n.name.trim() !== "")].sort((n, t) => n.name.localeCompare(t.name)).map((n) => ({
    value: n.org_id.toString(),
    name: n.name,
    label: n.name
  })) : [];
};
export {
  p as useOrganizationOptions
};
